module.exports = __webpack_public_path__ + "static/media/comment-alt-minus.c5f80ad4.svg";